import React, { useState } from 'react';
import { Popover, List, ListItem, ListItemText, Tooltip, IconButton } from '@mui/material';
import {  Visibility } from '@mui/icons-material';

const PopoverList = ({ label, items, displayField, separator = ' - ' }) => {
    const [anchorEl, setAnchorEl] = useState(null);

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const getLabel = (item) => {
        if (Array.isArray(displayField)) {
            return displayField.map(field => item[field]).join(separator);
        }
        return item[displayField];
    };


    const open = Boolean(anchorEl);
    const id = open ? 'simple-popover' : undefined;

    return (
        <div>
            <Tooltip title={label}>
                <IconButton variant="contained" onClick={handleClick} color='primary'>
                    <Visibility />
                </IconButton>
            </Tooltip>

            {/* Popover component */}
            <Popover
                id={id}
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left',
                }}
            >
                {/* List of items inside the popover */}
                <List>
                    {items.map((item, index) => (
                        <ListItem key={index}>
                            {/* Use dynamic field name here */}
                            <ListItemText primary={getLabel(item)} />
                        </ListItem>
                    ))}
                </List>
            </Popover>
        </div>
    );
};

export default PopoverList;
